import firebase from 'firebase';

export const getOrgTags = firebase.functions().httpsCallable('getOrgTags');
export const saveOrgTag = firebase.functions().httpsCallable('saveOrgTag');
export const deleteOrgTag = firebase.functions().httpsCallable('deleteOrgTag');

export default 'ManageOrgTags.api.js';
